import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import Typography from '@material-ui/core/Typography'
import React, { useContext } from 'react'
import * as TbIcons from 'react-icons/tb'
import { useHistory } from 'react-router-dom'

import colorContext from '../../../../Context/colorContext'
import stylesServiceProfile from './styles'

export interface ServiceProfile {
  atendimento_formflow: boolean
  autorizar_dois_fatores: boolean
  categoria_icone: string[]
  categoria_nome: string[]
  id: number
  nome_popular: string | null
  orgao_sigla: string
  publico_especifico: string[]
  servico_digital: boolean
  slug: string
  titulo: string
}
interface Props {
  listServiceProfile: ServiceProfile[]
}

const COLORS = [
  '#FF7C24',
  '#FA3198',
  '#27AC4F',
  '#3CCAF2',
  '#B2629F',
  '#FFAB2D',
]

export default function ServiceProfile({
  listServiceProfile,
}: Props): JSX.Element {
  const history = useHistory()
  const { colors } = useContext(colorContext)
  const classes = stylesServiceProfile({ colors })

  const renderShortIdRandom = () => {
    return Math.random().toString(36).substring(2, 6)
  }

  const renderIcons = (icon: string, size: number) => {
    const CurrentIcon = TbIcons[icon]

    if (!CurrentIcon) {
      return null
    }

    return (
      <CurrentIcon
        key={`${icon}-${renderShortIdRandom()}`}
        size={size}
        className={classes.itemIcon}
      />
    )
  }

  const ICONS = {
    Cidadão: renderIcons('TbMoodSmile', 32),
    Empresa: renderIcons('TbBuilding', 32),
    Servidor: renderIcons('TbUsersGroup', 32),
  }

  return (
    <Box className={classes.main}>
      <Box className={classes.contentTitle}>
        <Typography className={classes.textTitle}>Destaques</Typography>
      </Box>
      <Box className={classes.contentCards}>
        {listServiceProfile?.slice(0, 6).map((service, index) => (
          <Card
            className={classes.card}
            style={{ borderBottom: `16px solid ${COLORS[index]}` }}
            key={`${service.slug}-key-${index}`}
            onClick={(): void => history.push(`/servico/${service.slug}`)}
          >
            <Box className={classes.contentBody}>
              <Box className={classes.icons}>
                <span>{renderIcons(service?.categoria_icone?.[0], 42)}</span>
                <span>
                  {service.publico_especifico.map(
                    (public_specified: 'Cidadão' | 'Empresa' | 'Servidor') => {
                      return ICONS[public_specified]
                    },
                  )}
                </span>
              </Box>
              <Box className={classes.contentInfo}>
                <Typography className={classes.title}>
                  {service.titulo}
                </Typography>
                <Typography className={classes.subTitle}>
                  {service.orgao_sigla}
                </Typography>
              </Box>
            </Box>
          </Card>
        ))}
      </Box>
      <Box className={classes.contentActions}>
        <Button
          onClick={() => history.push('/servicos')}
          className={classes.button}
        >
          <Typography className={classes.textButton}>
            Todos os serviços
          </Typography>
        </Button>
      </Box>
    </Box>
  )
}
